<template>
  <base-container>
    <ArtisanGrid metaKey="SysMetaGrid">
    </ArtisanGrid>
  </base-container>
</template>

<script>
export default {

};
</script>

<style>
</style>